"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructAdr36SignDoc = void 0;
const constructAdr36SignDoc = (address, message) => {
    const msgSignData = { signer: address, data: Buffer.from(message).toString('base64') };
    const msgs = [{ type: 'sign/MsgSignData', value: msgSignData }];
    const fee = {
        gas: '0',
        amount: [],
    };
    const signDoc = {
        chain_id: '',
        account_number: '0',
        sequence: '0',
        fee,
        msgs,
        memo: '',
    };
    return signDoc;
};
exports.constructAdr36SignDoc = constructAdr36SignDoc;
